export default __webpack_public_path__ + "img/img1.4935067a.png";